import { render, staticRenderFns } from "./TailwindTableTabs.vue?vue&type=template&id=27cdc5c9&scoped=true&"
import script from "./TailwindTableTabs.vue?vue&type=script&lang=ts&"
export * from "./TailwindTableTabs.vue?vue&type=script&lang=ts&"
import style0 from "./TailwindTableTabs.vue?vue&type=style&index=0&id=27cdc5c9&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cdc5c9",
  null
  
)

export default component.exports